module.exports = __webpack_public_path__ + "assets/img/thumb-National-Media-Video.7e8abb6c.jpg";